export default "__VITE_ASSET__DQMaLYlb__"